import { useQuery, queryOptions } from '@tanstack/react-query';

import { STALE_TIMES } from '#lib/queryConstants';

import { fetchAllSignatures, fetchSignatureById } from '../../api/signatureApi';

import { signaturesKeys } from './keys';

export const signaturesOptions = () =>
	queryOptions({
		queryKey: signaturesKeys.list(),
		queryFn: async () => {
			const { data, error } = await fetchAllSignatures();
			if (error) throw error;
			return data ?? [];
		},
		staleTime: STALE_TIMES.STANDARD,
		retry: 2,
	});

export function useAllSignatures() {
	return useQuery(signaturesOptions());
}

export const signatureByIdOptions = (id) =>
	queryOptions({
		queryKey: signaturesKeys.detail(id),
		queryFn: async () => {
			const { data, error } = await fetchSignatureById(id);
			if (error) throw error;
			return data;
		},
		staleTime: STALE_TIMES.STANDARD,
	});

export function useSignatureById(id) {
	return useQuery({
		...signatureByIdOptions(id),
		enabled: Boolean(id),
	});
}
